import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'particle-data-survey-link',
  templateUrl: './data-survey-link.component.html',
  styleUrls: ['./data-survey-link.component.css']
})
export class DataSurveyLinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
